module.exports = __webpack_public_path__ + "img/cam_3_off.ce1a43e8.png";